import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

import "./Process.scss";

const steps = ["contract", "application", "confirmation", "referral"];

function Process() {
  const { t } = useTranslation();
  const sectionRef = useRef(null);

  useEffect(() => {
    const section = sectionRef.current;

    if (!section) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            section.classList.add("is-visible");
          });
        });

        observer.unobserve(section);
      },
      {
        threshold: 0,
        rootMargin: "0px 0px -20% 0px",
      }
    );

    observer.observe(section);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      className="partnership-process"
      aria-labelledby="partnership-process-title"
    >
      <div className="partnership-process__inner">
        <header className="partnership-process__header">
          <h2 id="partnership-process-title">
            {t("partnership.process.title")}
          </h2>

          <p>{t("partnership.process.description")}</p>

          <span
            className="partnership-process__accent"
            aria-hidden="true"
          />
        </header>

        <ol className="partnership-process__steps" role="list">
          {steps.map((step, index) => (
            <li
              className="partnership-process__step"
              key={step}
              style={{
                "--step-index": index,
              }}
            >
              <span className="partnership-process__number">
                {t("partnership.process.step", {
                  number: index + 1,
                })}
              </span>

              <h3>
                {t(`partnership.process.${step}.title`)}
              </h3>

              <p>
                {t(`partnership.process.${step}.description`)}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}

export default Process;